export const LENGTH_CARACTER = 4;
export const MAX_LENGTH = 20;
